<template>
  <PageWrap :page-title="pageTitle">
    <LoadingIndicator v-if="loadingData" class="mt-5" />

    <template v-else>
      <b-row>
        <b-col>
          <b-row class="mb-3">
            <b-col cols="12">
              <CodigoPostalForm
                :data="formData"
                :editing="isEditing"
                @update="updateForm"
                @updatecp="updateCodigoPostal"
                :errors="formErrors"
                :zonasSelector="zonasParaSelector"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <BfButton v-if="!isEditing" @click="createCodigoPostal">
        Guardar
      </BfButton>
  
    </template>
  </PageWrap>
</template>

<script>
import CodigoPostalForm from '@/components/FormGroups/CodigoPostalForm'
import FormSectionHeader from '@/components/FormSectionHeader'
import LoadingIndicator from '@/components/LoadingIndicator'
import PageWrap from '@/components/PageWrap'
import { delegationAPI, chargeAPI, codigosPostalesApi } from '@/api'

export default {
  name: 'DelegationsDetail',

  props: {
    id: {
      type: String,
    },
  },

  data() {
    return {
      formData: {},
      formErrors: {},
      loadingData: false,
      displayDeleteModal: false,
      zonasParaSelector: undefined,
    }
  },

  async created() {
    this.loadingData = true

    try {
      if (this.isEditing) {
        await this.loadData()
      }
    } finally {
      await this.prepareForm()

      this.loadingData = false
    }
  },

  methods: {
    async loadData() {
      console.log('Cargando datos')
      const { data } = await codigosPostalesApi.get(this.id)
      this.formData = data
      console.log('ejemplo')
      //  console.log(data);
    },
    async prepareForm() {
      const { zonas } = await codigosPostalesApi.preCreate()

      this.zonasParaSelector = zonas.map(({ nombre, id }) => ({
        label: nombre,
        value: id,
      }))
    },
    async updateForm({ key, value }) {
      const newData = { [key]: value }

      if (!this.isEditing) {
        this.formData = {
          ...this.formData,
          ...newData,
        }
      } else {
        this.formErrors = {}

        try {
          const { data, message } = await codigosPostalesApi.update({
            id: this.id,
            data: newData,
          })

          this.formData = data
          this.$bfNotify({ title: 'Actualizado', message, type: 'success' })
        } catch ({ errors, message }) {
          this.formErrors = errors
          this.$bfNotify({
            title: 'Error',
            message,
            type: 'error',
          })
        }
      }
    },
    async showDeleteModal() {
      this.displayDeleteModal = true
    },
    async createCodigoPostal() {
      try {
        this.formErrors = {}
        const { data, message } = await codigosPostalesApi.create(this.formData)

        this.$bfNotify({ title: 'Guardado', message, type: 'success' })
        this.$router.replace({ name: 'codigosPostales' })
      } catch ({ errors, message }) {
        this.formErrors = errors
        this.$bfNotify({
          title: 'Error',
          message: 'Existe un error con tus datos',
          type: 'error',
        })
      }
    },
    async updateCodigoPostal({ value }) {
      const valueLength = value.length
      if (valueLength >= 5) {
        try {
          const datosCp = await chargeAPI.autoCodigosPostales(value)
          this.formData.provincia = datosCp.provincia
          this.formData.poblacion = datosCp.poblacion
          this.formData.codigopostal = value
        } catch ({ errors, message }) {
          this.formErrors = errors
          this.$bfNotify({
            title: 'Error',
            message,
            type: 'error',
          })
        }
      }
    },
  },

  computed: {
    isEditing() {
      return !!this.id
    },

    pageTitle() {
      return this.isEditing
        ? `Código postal: ${this.formData.nombre || ''}`
        : 'Nuevo código postal'
    },
  },

  components: {
    CodigoPostalForm,
    FormSectionHeader,
    LoadingIndicator,
    PageWrap,
  },
}
</script>
